<div class="card rounded-2">
	<div class="card-body bg-gray-200  px-4 py-2">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<li class="nav-item">
				<a class="nav-link" data-bs-toggle="tab" routerLink="add">Add New</a>
			</li>
			<li class="nav-item">
				<a class="nav-link active" data-bs-toggle="tab" href="#performa_pane_2">Manage</a>
			</li>
		</ul>
		<div class="tab-content" id="myTabContent">
			<!-- <div class="tab-pane fade" id="performa_pane_1" role="tabpanel">
				<app-proforma-add-new></app-proforma-add-new>
			</div> -->
			<div class="tab-pane fade show active" id="performa_pane_2" role="tabpanel">
				<app-proforma-list></app-proforma-list>
			</div>
		</div>
	</div>
</div>


